import { useEffect, useMemo, useState } from "react";

import style from "./index.module.css";

import {
  Box,
  Divider,
  Drawer,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { BsFillPersonFill } from "react-icons/bs";
import { IoMdMenu } from "react-icons/io";
import { MdOndemandVideo } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { shareURL } from "../../config/axiosAuth";
import { getUserProfileDetails } from "../../redux/features/getUserProfile";
import {
  getVisaLancerDashboard,
  ShareVisaLancerLink,
} from "../../services/services";
import { ReactComponent as QuestionSvg } from "../../assets/questionIcon.svg";
import E_VisaModal from "./e-VisaModal";
import HowItsWork_Carousel from "../Profile/howItsWork";

let heroImages = [
  "/assets/images/home1.jpg",
  "/assets/images/home2.jpg",
  "/assets/images/home3.jpg",
  "/assets/images/home4.jpg",
  "/assets/images/home5.jpg",
];

const generateShareURL = async (user_id, session_id) => {
  try {
    const request = await ShareVisaLancerLink(user_id, session_id);
    const response = await request.data;
    if (response.status == 1) {
      return `${shareURL}/visa-lancer?visa_lancer_code=${response?.data?.visa_lancer_code}`;
    }
  } catch (error) {
    console.log(error);
  }
};

const HomeScreen = () => {
  const [hero_image, setHero_image] = useState("");
  const [sharURL, setShareURL] = useState("");
  const [isSafari, setIsSafari] = useState(false);
  const [isHowItsWork, setHowItsWork] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileData, setProfileData] = useState();
  const open = Boolean(anchorEl);

  const user_id = localStorage.getItem("userId");
  const session_id = localStorage.getItem("session_id");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.userProfile?.result?.data);

  const handleE_Visa_App = async () => {
    const VisaURL = await generateShareURL(user_id, session_id);
    setShareURL(VisaURL);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // if (isSafari) {
    setIsSafari(true);
    // } else {
    //   window.open(VisaURL, "_blank");
    // }
  };

  const handleShareEarn = async () => {
    const URL = await generateShareURL(user_id, session_id);

    // const shareText = [
    //   "*Hello,*",
    //   "Break the cycle of burnout with our Free App and earn when your referrals apply for a Travel Visa. For Life !",
    //   "",

    //   "*It's easy !*",
    //   "Register, get a unique tracking code, Share and monitor earning !",

    //   "*What are you sharing?*",
    //   "App for Travel e-Visas to 60+ countries",
    //   "eTA and ESTA to USA, UK and Canada with",
    //   "free US$ 10,000 Insurance, Auto-form",
    //   "filling, Visa tracking, GDPR compliant etc.",
    //   "",
    //   URL,
    //   "",
    // ].join("\n");

    const shareText = [
      "Great news for International Travellers!",
      "",
      "Visaero is a Travel App for e-Visa to 60+ countries and eTA and ESTA to USA, UK and Canada with Free US$ 10,000 insurance.",
      "",
      "*Why Visaero?*",
      "- Save time with auto form-filling.",
      "- Free travel insurance worth US$ 10,000.",
      "- Travel visa status with real-time updates.",
      "- Stay secure with passcode protection.",
      "- GDPR certified for Data Privacy.",
      "- We do not share your data.",
      "",
      "Complete your visa journey in minutes, from the comfort of your home.",
      "",
      URL,
      "",
      "VisaLancer for T3 Visas.",
    ].join("\n");

    if (!URL) return;
    if (navigator.share) {
      await navigator
        .share({
          title: "Share & Earn",
          text: shareText,
          // url: URL,
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useMemo(() => {
    dispatch(getUserProfileDetails(user_id)); //call user profile API
  }, [user_id]);

  const getVisaeroDashboardData = async () => {
    try {
      const request = await getVisaLancerDashboard();
      const response = await request.data;
      setProfileData(response?.data);
    } catch (error) {
      console.log(error);
    }
  };
  console.log("profileData", profileData);
  useEffect(() => {
    getVisaeroDashboardData();
  }, []);

  useEffect(() => {
    // set random heroImages when component rerender each time
    const randomNum = Math.floor(Math.random() * heroImages.length);
    setHero_image(heroImages[randomNum]);
  }, []);

  return (
    <Box
      className="home_container"
      style={{ height: "100svh", position: "fixed", width: "100%" }}
    >
      <div
        style={{
          position: "absolute",
          height: "100svh",
          bottom: 0,
          left: 0,
          right: 0,
          background:
            // "linear-gradient(359.54deg, rgba(0, 0, 0, 0.99) 26.99%, rgba(0, 0, 0, 0.2) 38.83%, rgba(0, 0, 0, 0.2) 44.12%)",
            "linear-gradient(359.54deg, rgba(0, 0, 0, 0.99) 26.99%, rgba(0, 0, 0, 0.2) 50.83%, rgba(0, 0, 0, 0.2) 44.12%)",
        }}
      />
      <Drawer
        anchor="bottom"
        PaperProps={{
          elevation: 0,
          style: { backgroundColor: "transparent", height: "100svh" },
        }}
        open={isSafari}
        onClose={() => setIsSafari(false)}
      >
        <E_VisaModal URL={sharURL} close={() => setIsSafari(false)} />
      </Drawer>

      <Drawer
        anchor="bottom"
        PaperProps={{
          elevation: 0,
          style: { backgroundColor: "transparent", height: "100svh" },
        }}
        open={isHowItsWork}
      >
        <HowItsWork_Carousel close={setHowItsWork} />
      </Drawer>

      <Box className={style.hero_section}>
        <img src={process.env.PUBLIC_URL + hero_image} alt="hero img" />
      </Box>
      <Box className={style.home_headerSection}>
        <Box className={style.profile_section}>
          <Box
            className={style.home_profile}
            onClick={() => navigate("profile")}
            style={{
              backgroundColor: "gray",
              height: 40,
              width: 40,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {userDetails?.profile_signed_url ? (
              <img
                src={userDetails?.profile_signed_url}
                style={{ objectFit: "cover" }}
                key={new Date().valueOf()}
                alt="profile img"
              />
            ) : (
              <BsFillPersonFill
                style={{
                  margin: 0,
                  height: "2rem",
                  width: "3rem",
                  objectFit: "cover",
                }}
              />
            )}
          </Box>

          <div className={style.user_information}>
            <span>
              {profileData?.connected_user}{" "}
              {profileData?.connected_user > 1 ? "Users" : "User"}
            </span>
            <span>
              {profileData?.visa} {profileData?.visa > 1 ? "Visas" : "Visa"}
            </span>
            <span>{profileData?.lifetime_earning} Income</span>
          </div>
        </Box>

        <div>
          <div
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            className={style.centerIcon}
          >
            <IoMdMenu
              style={{
                height: "2rem",
                width: "2rem",
                color: "white",
                margin: 0,
              }}
            />
          </div>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            // PaperProps={{ sx: { p: 1 } }} // padding inside Paper (box)
            MenuListProps={{ sx: { p: 1 } }} // padding inside the MenuList (ul)
          >
            <MenuItem
              autoFocus={false}
              sx={{ padding: "0px 10px" }}
              onClick={() => {
                handleClose();
                navigate("/help-video");
              }}
              className={style.menu_text}
            >
              <MdOndemandVideo style={{ marginRight: "0.5rem" }} />
              Help Video
            </MenuItem>
            <Divider />
            <MenuItem
              autoFocus={false}
              sx={{ padding: "0px 10px" }}
              onClick={() => {
                handleClose();
                setHowItsWork(true);
              }}
              className={style.menu_text}
            >
              <QuestionSvg style={{ marginRight: "0.5rem" }} />
              How it Works
            </MenuItem>
          </Menu>
        </div>
      </Box>
      <Box className={style.home_mainContain}>
        <Typography variant="h4">
          Hello, {userDetails && userDetails?.first_name}
        </Typography>
        <p className={style.mainContentDesc}>
          Start sharing or apply for your customer!
        </p>
      </Box>

      <Box className={style.home_menuSections}>
        <Box
          style={{ display: "flex", justifyContent: "end" }}
          onClick={() => {}}
        >
          <Box className={style.home_boxContainer} onClick={handleShareEarn}>
            <h6 className={style.boxContainerTitle}>Share & Earn</h6>
            <div className={style.borderLine} />
            <Box>
              <img
                alt="share icon"
                src={
                  process.env.PUBLIC_URL + "/assets/images/home/share_icon.svg"
                }
                className={style.box_icon}
              />
            </Box>
          </Box>
        </Box>
        <Box onClick={handleE_Visa_App}>
          <Box className={style.home_boxContainer}>
            <h6 className={style.boxContainerTitle}> e-Visa App</h6>
            <div className={style.borderLine} />
            <Box>
              <img
                alt="box icon"
                // src={appImage}
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/visa_mobile_icon.svg"
                }
                className={style.box_icon}
              />
            </Box>
          </Box>
        </Box>
        <Box style={{ display: "flex", justifyContent: "end" }}>
          <Box
            className={style.home_boxContainer}
            onClick={() => {
              navigate("dashboard");
            }}
          >
            <h6 className={style.boxContainerTitle}>My Dashboard</h6>
            <div className={style.borderLine} />
            <Box>
              <img
                alt="dashboard icon"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/dashboard_icon.svg"
                }
                className={style.box_icon}
              />
            </Box>
          </Box>
        </Box>
        <Box>
          <Box
            className={style.home_boxContainer}
            onClick={() => navigate("customer-benefits")}
          >
            <h6 className={style.boxContainerTitle}> Client Benefits</h6>
            <div className={style.borderLine} />
            <Box>
              <img
                alt="user profile icon"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/user_profile_icon.svg"
                }
                className={style.box_icon}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HomeScreen;
